import { Skeleton } from "@dafiti/closet-ui";

export function CatalogCardSkeleton() {
  return (
    <div className="w-full" data-testid="catalog-card-skeleton">
      <Skeleton className="rounded-lg aspect-131/190 h-auto" />

      <div className="mt-1 mb-1 lg:mb-1.5">
        <Skeleton className="w-1/3 h-3.75 xl:h-4.5 rounded-none" />
      </div>

      <Skeleton className="w-full h-4.5 xl:h-10.5 2xl:h-5.25 mb-0.5 rounded-none" />

      <div className="mt-1 flex flex-col gap-0.5">
        <Skeleton className="h-11 w-full rounded-none" />
      </div>
    </div>
  );
}
